import { Checkbox, Field, Input } from '@/components/field'
import type { UserDraft } from '@/features/platform-users/user-draft'
import { useT } from '@/lib/i18n/translate'

interface UserFieldsProps {
  value: UserDraft
  onChange: (next: UserDraft) => void
  /** The email field's server verdict (`INVALID_EMAIL` / `EMAIL_TAKEN`). */
  emailError?: unknown
}

/** Email + names + the admin flag, shared by create and edit. */
export function UserFields({ value, onChange, emailError }: UserFieldsProps) {
  const t = useT()
  return (
    <>
      <Field label={t('auth.email')} error={emailError}>
        <Input
          type="email"
          autoComplete="off"
          required
          value={value.email}
          onChange={(e) => onChange({ ...value, email: e.target.value })}
        />
      </Field>
      <Field label={t('auth.firstName')}>
        <Input autoComplete="off" value={value.firstName} onChange={(e) => onChange({ ...value, firstName: e.target.value })} />
      </Field>
      <Field label={t('auth.lastName')}>
        <Input autoComplete="off" value={value.lastName} onChange={(e) => onChange({ ...value, lastName: e.target.value })} />
      </Field>
      <div className="flex flex-col gap-1">
        <Checkbox
          label={t('users.isAdmin')}
          checked={value.isAdmin}
          onChange={(e) => onChange({ ...value, isAdmin: e.target.checked })}
        />
        <p className="text-muted text-sm">{t('users.isAdminHint')}</p>
      </div>
    </>
  )
}
